var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredictorGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 12,
    viewBox: "0 0 90 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 11,
    rx: 5.5,
    fill: "#F3F3F3",
    stroke: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 0.5,
    width: 29,
    height: 11,
    fill: "#F3F3F3",
    stroke: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0H84C87.3137 0 90 2.68629 90 6V6C90 9.31371 87.3137 12 84 12H60V0Z",
    fill: "#03DD6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictorGreen);
export default __webpack_public_path__ + "static/media/predictorGreen.dbea1f0b228054f6ae084c769737059b.svg";
export { ForwardRef as ReactComponent };